import { render, staticRenderFns } from "./InspectionCommissionDetailsModal.vue?vue&type=template&id=1d151288&scoped=true&"
import script from "./InspectionCommissionDetailsModal.vue?vue&type=script&lang=js&"
export * from "./InspectionCommissionDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d151288",
  null
  
)

export default component.exports